<div [@routerTransition]>



  <div class="certificat-verify">
    <div class="row card-deck">
      <!--User Profile wizard Starts-->
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form">
        <section id="paging" class="mb-3">

          <div class="row">
            <div class="col-12 padding-l-0px">
              <div class="card credential">
                <div class="card-header  wh-header card-title-credentials-bb card-title-credentials-bl padding-tb-5">
                  <i class="fas fa-certificate"></i>
                  Credentials Verification
                  <div class="float-right">
                    <!--<button class="btn actions-btn-prime2" (click)="onprint()">Print</button>-->
                    <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
                  </div>
                  <!--<div class="row">
    <div class="col-md-10 pink">


    </div>
    <div class="col-md-2 float-right padding-lr-0px">

    </div>
  </div>-->
                  <!--<div class="row">
    <div class="col-md-10 pink">

    </div>

  </div>-->

                </div>
                <div class="card-body search-body ">
                  <div class="row search-box" *ngIf="CurrentAllActorCertificatesInfoController" hidden>
                    <div class="col-md-10">
                      <ul class="search-result-box">
                        <li class="d-md-table-cell col1">
                          <span class="pink-round-broder"><img src="../../../../../../../wwwroot/healins-assets/images/admin/certificates.png"></span>
                        </li>
                        <li class="d-md-table-cell col2 v-top pl-3">
                          <div class="mt-3 skill-status">
                            You have successfully Added
                            <!--Uploaded-->
                            <br>
                            Total <span class="prime-color fb"> {{CurrentAllActorCertificatesInfoController.length}} Credentials</span>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <!-- welcome titie Start -->

                  <div class="card-content">
                    <div class="panel-heading">
                      <div *ngIf="CurrentAllActorCertificatesInfoController;let RowIndex =index" class="row">
                        <div class="col-12 padding-l-0px">

                          <!--<h6 class="panel-title fb">List of Credentials</h6>-->
                          <div *ngIf="CurrentAllActorCertificatesInfoController.length >0" class="col-12 padding-top2" >
                             
                            <!--<div class="row" style="padding:unset;" hidden>
                              <div class="mt-3 skill-status" style="padding:20px;padding-bottom:unset;padding-top:unset">Init <span class="badge badge-info">{{CurrentAllActorCertificatesInfoController[0].TotalDocInitiated}} </span></div>
                              <div class="mt-3 skill-status" style="padding:20px;padding-bottom:unset;padding-top:unset">Ack <span class="badge badge-info">{{CurrentAllActorCertificatesInfoController[0].TotalDocInitiated}}</span></div>
                              <div class="mt-3 skill-status" style="padding:20px;padding-bottom:unset;padding-top:unset">In Proc <span class="badge badge-info">{{CurrentAllActorCertificatesInfoController[0].TotalDocInProcess}}</span></div>
                              <div class="mt-3 skill-status" style="padding:20px;padding-bottom:unset;padding-top:unset">Await <span class="badge badge-info">{{CurrentAllActorCertificatesInfoController[0].TotalDocWaitingForResponse}}</span></div>
                              <div class="mt-3 skill-status" style="padding:20px;padding-bottom:unset;padding-top:unset">Cancel <span class="badge badge-info">{{CurrentAllActorCertificatesInfoController[0].TotalDocCancelled}} </span></div>
                              <div class="mt-3 skill-status" style="padding:20px;padding-bottom:unset;padding-top:unset">Fail <span class="badge badge-info">{{CurrentAllActorCertificatesInfoController[0].TotalDocFailed}}</span></div>
                              <div class="mt-3 skill-status" style="padding:20px;padding-bottom:unset;padding-top:unset">Success <span class="badge badge-info">{{CurrentAllActorCertificatesInfoController[0].TotalDocSuccess}}</span></div>
                            </div>-->
                            

                          </div>

                          <div class="table-component">
                            <div class="table-responsive">
                              <!--<search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>-->

                              <table class="table table-striped margin-left-zero">
                                <thead class="">
                                  <tr>
                                    <!--<th scope="col" >S.NO</th>-->
                                    <th scope="col" [class]="selectedClass('CredentialType')" (click)="changeSorting('CredentialType')">Title</th>
                                    <th scope="col" [class]="selectedClass('CertificateType')" (click)="changeSorting('CertificateType')">Type</th>
                                    <th scope="col" [class]="selectedClass('CredentialNumber')" (click)="changeSorting('CredentialNumber')">Number</th>
                                    <th scope="col" [class]="selectedClass('IssuingAuthorityLongValue')" (click)="changeSorting('IssuingAuthorityLongValue')">Issuing Authority</th>
                                    <th scope="col" [class]="selectedClass('AdditionalDetail')" (click)="changeSorting('AdditionalDetail')">Additional Details</th>
                                    <th scope="col" [class]="selectedClass('Remarks')" (click)="changeSorting('Remarks')">Remarks</th>
                                    <!--<th scope="col">Status</th>-->
                                   
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr *ngFor="let l of pdata  | orderby : convertSorting();let RowIndex =index">
                                    <!--<td>{{RowIndex+1}}</td>-->
                                    <td>{{l.CredentialType}}</td>
                                    <td>{{l.CertificateType}}</td>
                                    <td>{{l.CredentialNumber}}</td>
                                    <td>{{l.IssuingAuthorityLongValue}}</td>
                                    <td>{{l.AdditionalDetail}}</td>
                                    <td class="word">{{l.Remarks}}</td>
                                    <!--<td class="success">
                                      {{l.DocVerStatus}}
                                     
                                    </td>-->
                                   
                                  </tr>

                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                     
                    </div>
                  </div>
                </div>
              </div>
              </div>
            </div>
        </section>

        <!--User Profile wizardEnd-->
      </div>

    </div>
    </div>

  </div>
